<template>
  <div>
    <div class="entertainment-card" v-for="(packItem,index) in listData" :key="index">
      <div class="item-top-tag">{{packItem.name}}</div>
      <div class="flex-between-box" v-for="(item ,i) in packItem.children" :key="i">
        <div class="bd-left">
          <van-image
          width="1.9rem"
          height="1.2rem"
          class="list-image"
          fit="cover"
          :src="item.mobileBanner"
          @click="goDetail(item)"
          />
          <!-- <img class="union-pay-ico" src="../../assets/union_pay_ico.png" alt=""> -->
          <div class="label" v-show="item.promotionImage">
            <img class="label-img" :src="item.promotionImage" />
          </div>
        </div>
        <div class="bd-right">
          <div class="list-title">{{item.name}}</div>
          <div class="list-price">
            <div class="price-left"> <span class="price-color">{{priceFormat(item.priceDiscounted)}}</span> {{(item.PriceByRouteDays||item.priceByRouteNights)? '美元/航次' : item.priceUnit}} <span class="number">x{{item.qty}}</span></div>
            <div class="price-right"> <span class="price-color">{{priceFormat(item.priceDiscounted * item.qty)}}</span> 美元</div>
          </div>
          <div class="entertainment-item" v-if="item.packageItems.length > 0">
            <div class="flex-center-box" v-for="(packageitem, key) in item.packageItems" :key="key">
              <div class="blue-color el">{{packageitem.name}}</div>
              <div class="item-time el">{{packageitem.shipDate}}  {{packageitem.timeSlotStartTime}}-{{packageitem.timeSlotEndTime}}</div>
            </div>
          </div>
          <div class="list-time blue-color" v-if="item.timeSlotStartTime">{{item.shipDate}}  {{item.timeSlotStartTime}}-{{item.timeSlotEndTime}}</div>
          <div class="list-tips blue-color" v-if="item.priceByRouteNights || item.priceByRouteDays">全程</div>
          <div class="order-detail">
            <div class="detail-list" v-for="(guest,i) in item.bookingGuestAndStateroomNumbers" :key="i">
              <div><span>船票订单号:{{guest.bookingId}}</span> <span>房间号:{{guest.stateroomNumber}}</span></div>
              <div>
                <span v-for="(persons,personIndex) in guest.bookingGuest.guestPersons" :key="personIndex">{{persons.pyLastName}}/{{persons.pyFirstName}}{{guest.bookingGuest.guestPersons.length === personIndex + 1 ? '' : ','}}</span>
              </div>
            </div>
          </div>
          <div class="card-btn" v-if="isShow">
            <div class="edit-button">
              <van-button class="item-btn" @click="showDialogBooking(item)">编辑</van-button>
              <van-button class="item-btn btn-linear-gradient" @click="deleteBtn(item.id)">删除</van-button>
              <!-- 编辑弹框 -->
              <dialog-booking :visible.sync="editShow" :goodsInfo="currentProduct" @submitSuccess="submitSuccess"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DialogBooking from '@/views/DialogBooking'
import { Dialog } from 'vant'
import { showAlert } from '@/utils/tools'
import api from '@/api'
import pick from 'lodash/pick'
import { gioTracking } from '@/plugins/common'
// import uniq from 'lodash/uniq'

export default {
  name: 'EntertainmentCard',

  components: {
    DialogBooking
  },

  data () {
    return {
      editShow: false,
      currentProduct: {},
      listData: []
    }
  },

  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    },
    allBookingGuests: Array
  },
  watch: {
    cardData: {
      handler (val) {
        this.listData = val
      },
      deep: true
    }
  },
  created () {
    this.listData = this.cardData
  },
  // computed: {
  //   cardDataFormat () {
  //     return this.cardData.map(x => {
  //       const productIds = uniq(x.packageItems.map(j => j.productId))
  //       return {
  //         ...x,
  //         packageItems: productIds.map(j => (x.packageItems.find(y => y.productId === j)))
  //       }
  //     })
  //   }
  // },

  methods: {
    priceFormat (current) {
      return current % 1 === 0 ? current : current.toFixed(2)
    },
    showDialogBooking ({ productId, id, bookingGuestAndStateroomNumbers, ...current }) {
      this.currentProduct = {
        ...pick(current, ['name', 'mobileBanner', 'applyTo', 'needSync', 'qty', 'shipDate', 'timeSlot', 'packageItems', 'categoryName']),
        id: productId,
        shoppingCartId: id,
        initBookingGuests: bookingGuestAndStateroomNumbers.map(({ ...others }) => ({
          ...others,
          bookingGuests: this.allBookingGuests.filter(j => j.bookingRecord_Id === others.bookingRecordId).map(x => ({ ...x, canSelect: true }))
        })),
        initBookingGuestsChoosed: [].concat.apply([], bookingGuestAndStateroomNumbers.map(x => x.bookingGuest.guestPersons.map(j => j.id)))
      }
      this.editShow = true
    },
    deleteBtn (val) {
      Dialog.confirm({
        message: '确定要删除该产品？'
      }).then(() => {
        // on confirm
        this.deleteProduct(val)
      }).catch(() => {
        // on cancel
      })
    },
    async deleteProduct (val) {
      const { errCode, errMsg } = await api.deleteProduct({ shoppingCartId: val })
      if (errCode === 0) {
        this.$emit('deleteRefreh')
      } else {
        showAlert(errMsg)
      }
    },
    submitSuccess () {
      this.$emit('deleteRefreh')
    },
    goDetail (val) {
      gioTracking('track','evt_prdClick', {'productID': val.productId,'Product_Category': val.categoryName, 'Product_DetailProduct': val.name })
      this.$router.push(`/Rccl.PCP/product/detail/${val.productId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.entertainment-card{
  font-size: 20px;
  padding: 20px 20px 0;
  .flex-between-box {
    margin-bottom: 30px;
  }
  .item-top-tag{
    font-size: 26px;
    color: @main-gray3;
    padding: 5px 20px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 46px;
    padding-bottom: 0px;
  }
  .list-image{
    display: block;
    margin-bottom: 15px;
  }
  .bd-left{
    width: 190px;
    .union-pay-ico{
      width: 140px;
      height: 30px;
      display: block;
      padding: 0;
      margin: 0;
    }
  }
  .bd-right{
    flex: 1;
    padding-left: 30px;
    .list-title{
      font-size: 26px;
      color: @main-color;
      margin-bottom: 5px;
      margin-top: -5px;
    }
    .list-price{
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 10px;
      .number{
        display: inline-block;
        margin-left: 10px;
      }
      .price-left{
        font-size: 20px;
      }
      .price-right{
        .price-color{
          font-size: 30px;
        }
      }
    }
    .entertainment-item{
      margin-bottom: 28px;
      font-size: 20px;
      .blue-color{
        padding-right: 10px;
        flex: 1;
      }
    }
    .list-time{
      margin-bottom: 20px;
    }
    .list-tips{
      margin-bottom: 20px;
    }
    .order-detail{
      .detail-list{
        margin-bottom: 25px;
      }
    }
  }
  .label {
    // width: 180px;
    margin-top: 10px;
    img{
      // width: 100%;
      height: 30px;
    }
    // display: flex;
    // flex-wrap: nowrap;
    // padding-top: 12px;
    // .label-item {
    //   display: flex;
    //   align-items: center;
    //   height: 30px;
    //   margin-right: 12px;
    //   margin-bottom: 12px;
    //   padding: 0 20px 0 16px;
    //   border-radius: 15px;
    //   font-size: 20px;
    //   color: #1174b8;
    //   background-color: #e8f4fe;
    //   .label-img {
    //     flex: none;
    //     width: 26px;
    //     margin-right: 6px;
    //   }
    // }
  }
}
</style>
